import { render, staticRenderFns } from "./collaborativeManagement.vue?vue&type=template&id=29c38bee&scoped=true"
import script from "./collaborativeManagement.vue?vue&type=script&lang=js"
export * from "./collaborativeManagement.vue?vue&type=script&lang=js"
import style0 from "./collaborativeManagement.vue?vue&type=style&index=0&id=29c38bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c38bee",
  null
  
)

export default component.exports